import axios from "axios"
import { EventBus } from "../src/event_bus"

const POSITIVE_RESPONSE_CODES = [200, 201]

export default class {
  constructor(file, videoCreationUrl) {
    this.id = Math.floor(Math.random() * 1_000_000_000).toString() // TODO: Use a UUID.
    this.file = file
    this.filename = file.name
    this.videoCreationUrl = videoCreationUrl
    this.videoData = null
  }

  isValid() { return !!this.file }

  async fetchUploadData() {
    if (!this.isValid()) { return }

    const videoData = await this.createVideo()
    this.videoData = videoData

    if (!this.videoData?.temporary_upload_url) {
      console.error(`Failed to fetch upload URL for ${this.filename}`)
      return
    }

    return true
  }

  async startUpload() {
    try {
      const response = await axios.put(
        this.videoData.temporary_upload_url,
        this.file,
        {
          onUploadProgress: (progressEvent) => {
            EventBus.emit("video-upload:progress", {
              id: this.id,
              progressEvent: progressEvent
            })
          }
        }
      )

      if (!response) {
        console.error(`Failed to receive an upload response for ${this.filename}.`)
        return
      }

      // Success!
      if (POSITIVE_RESPONSE_CODES.includes(response.status)) {
        EventBus.emit("video-upload:success", { id: this.id })
        this.finishUpload()
      }
    } catch(e) {
      console.error(`Failed to upload ${this.filename}: ${e}`)
      EventBus.emit("video-upload:error", { id: this.id })
    }
  }

  async finishUpload() {
    await axios.post(this.videoData.finish_url)
  }

  async createVideo() {
    const response = await axios.post(this.videoCreationUrl, {
      video: {
        original_file_name: this.filename,
        title: this.filename
      }
    })

    return response?.data
  }
}
